import React, { Component } from 'react'

export default class NotFound extends Component {
    render() {
        return (
            <div style={{ padding: '40px' }}>
                404 Not Found
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js